import { render, staticRenderFns } from "./ParticipantBatch.vue?vue&type=template&id=4baf0697&scoped=true"
import script from "./ParticipantBatch.vue?vue&type=script&lang=js"
export * from "./ParticipantBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf0697",
  null
  
)

export default component.exports